import { createContext, useContext, useEffect, useState } from "react";
import { createUrl, get, post } from "../network/AxiosInterceptor";

const TripContext = createContext();

export const TripProvider = ({ children }) => {
  const [trips, setTrips] = useState();

  const fetchTrips = (setFunction,props) => {
    post(createUrl(`/api/trips/listing`), {})
      .then((res) => {
        const fetchedTrips = res?.data?.trips;
        const currDate = new Date().getTime();
        const updatedTrips = fetchedTrips.filter((trip) => {
          const tripDateArr = trip.tripDates.filter((dt) => {
            if (dt.from > currDate) {
              return dt;
            }
          });
          trip.tripDates = tripDateArr;
          if (tripDateArr.length > 0) {
            const tripDate = trip.tripDates[0].from.getTime();
            if (tripDate > currDate) {
              return trip;
            }
          }
        });
        setTrips(updatedTrips);
        if(props.home){
          setFunction(updatedTrips.slice(0,9));
        }else
        setFunction(updatedTrips);
        
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <TripContext.Provider value={{ trips, setTrips,fetchTrips }}>
      {children}
    </TripContext.Provider>
  )
};

export const useTrip = () => {
  return useContext(TripContext);
};
